import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { ofType, Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable, of, race, map } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { RequisitionsActions } from '@recruitee/requisitions-data';

@Injectable({ providedIn: 'root' })
export class RequisitionsPageGuard {
  constructor(
    private store: Store,
    private router: Router,
    private actions$: Actions,
  ) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const id = route.params.id;
    this.store.dispatch(RequisitionsActions.fetchOne({ payload: { id } }));

    const success$ = this.actions$.pipe(ofType(RequisitionsActions.fetchOneSuccess));
    const failed$ = this.actions$.pipe(ofType(RequisitionsActions.fetchOneFailed));

    return race(success$, failed$).pipe(
      map(action => action.type === RequisitionsActions.fetchOneSuccess.type),
      switchMap(isSuccess =>
        isSuccess
          ? of(true)
          : this.router.navigateByUrl('/requisitions/access-denied', { replaceUrl: true }),
      ),
    );
  }
}
